import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import ChatList from './components/ChatList';
import ChatWindow from './components/ChatWindow';

import './App.css';

const contacts = [
  {
    id: 1,
    avatar: process.env.PUBLIC_URL + '/assets/charlie_james.png',
    name: 'Charlie James',
    lastMessage: "Hi dear! Just checking in to see how you're doing.",
    messages: []
  },
  {
    id: 2,
    avatar: process.env.PUBLIC_URL + '/assets/anna_rees.png',
    name: 'Anna Rees',
    lastMessage: "Hey Jane, do you have a moment? 🙏🏻",
    messages: []
  },
  {
    id: 3,
    avatar: process.env.PUBLIC_URL + '/assets/isla_ansen.png',
    name: 'Isla Hansen',
    lastMessage: "Hey! Guess what? I just got two tickets to that concert that we talked about",
    messages: []
  },
  {
    id: 4,
    avatar: process.env.PUBLIC_URL + '/assets/harry_vasquez.png',
    name: 'Harry Vasquez',
    lastMessage: "Hey! Are you free this weekend? I found this restaurant that is so good!",
    messages: []
  },
  {
    id: 5,
    avatar: process.env.PUBLIC_URL + '/assets/celine_perry.png',
    name: 'Celine Perry',
    lastMessage: "Hi how are you? 😁 It’s been a long long time!",
    messages: []
  }
];

const App = () => {
  const [selectedContact, setSelectedContact] = useState(null);
  const [message, setMessage] = useState('');
  const [contactMessages, setContactMessages] = useState({});
  const [isMobileView, setIsMobileView] = useState(false);
  const [showChatList, setShowChatList] = useState(true);

  const handleSendMessage = (message) => {
    if (selectedContact) {
      const updatedMessages = {
        ...contactMessages,
        [selectedContact.id]: [...(contactMessages[selectedContact.id] || []), message],
      };

      setContactMessages(updatedMessages);
      setSelectedContact({
        ...selectedContact,
        messages: updatedMessages[selectedContact.id],
      });
    }
  };

  const handleChatSelect = (contact) => {
    setSelectedContact(contact);
    if (isMobileView) {
      setShowChatList(false); // Hide ChatList on mobile when a contact is selected
    }
  };

  const handleBackToList = () => {
    setShowChatList(true);
    setSelectedContact(null);
  };

  // Detect screen width for mobile responsiveness
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
        setShowChatList(true); // Reset to show the chat list on larger screens
      }
    };
    
    handleResize(); // Check initial screen size
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="app">
      <Navbar />
      <div className="main-content">
        {isMobileView && !showChatList && (
          <button onClick={handleBackToList} className="back-button animated"><span className="material-symbols-rounded">
          arrow_back
          </span></button>
        )}

        <div className={`chat-container ${isMobileView ? 'mobile-view' : ''}`}>
          {showChatList && (
            <ChatList
              contacts={contacts}
              selectedContact={selectedContact}
              setSelectedContact={handleChatSelect}
              contactMessages={contactMessages}
            />
          )}

          {selectedContact && (
            <ChatWindow
              selectedContact={selectedContact}
              handleSendMessage={handleSendMessage}
              message={message}
              setMessage={setMessage}
              contactMessages={contactMessages}
              onBack={handleBackToList}
            />
          )}
        </div>
      </div>
    </div>
  );
};


export default App;
